// Stuck wrap-up (Storm 2026-10-22 14:02): the wrap-up saved, but Connect had
// already finished the contact (the agent picked a status during wrap-up), so
// contact.clear() failed and the screen could not be left. If Connect no
// longer reports the contact, the save is all that was needed: treat the
// wrap-up as complete. Pure helper for scripts/verify-wrapup-complete.mjs.

const idOf = c => { try { return c?.getContactId?.() ?? null; } catch { return null; } };

// true when Streams still lists the contact for this agent (so a retry makes sense)
export function contactStillPresent(contacts, contactId) {
  if (!contactId || !Array.isArray(contacts)) return false;
  return contacts.some(c => idOf(c) === contactId);
}

// The status menu is locked while a wrap-up is open (standard practice: time
// in wrap-up is measured, and a status change could finish the contact early).
export const STATUS_LOCKED_NOTE = 'Finish wrap-up first';
export function statusLocked({ wrapContext }) { return !!wrapContext; }
